module.exports = __webpack_public_path__ + "static/img/partInquriy1.6b924949.png";